import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferGetPathParameters } from 'api/actions/price-offer-get/price-offer-get-path-parameters';
import { PriceOfferGetResponse } from 'api/actions/price-offer-get/price-offer-get-response';

type PriceOfferGetQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferGet action.
 */
export const priceOfferGetActionPath = new SweetPath<keyof PriceOfferGetPathParameters>(
  '/api/price-offer/get/{priceOfferId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferGet actions.
 */
export default function createPriceOfferGetAction(axios: AxiosInstance) {
  return function priceOfferGetAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PriceOfferGetPathParameters;
    query?: PriceOfferGetQueryParameters;
  }) {
    const path = priceOfferGetActionPath.insert(parameters);

    return axios.request<PriceOfferGetResponse, PriceOfferGetResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
